import { render, staticRenderFns } from "./insertPaymentGateway.vue?vue&type=template&id=7414050b"
import script from "./insertPaymentGateway.vue?vue&type=script&lang=js"
export * from "./insertPaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./insertPaymentGateway.vue?vue&type=style&index=0&id=7414050b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports